import type { SagaIterator } from "redux-saga";
import { all, call, put, takeLeading } from "redux-saga/effects";
import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as catalogApi from "@/shop/api/catalog";

import * as CatalogActions from "./actions";
import type { ICatalogTreeSlice } from "../../types/catalog";

function* fetchBaseCategoriesSaga(action: ActionType<typeof CatalogActions.fetchBaseCategories>): SagaIterator {
  try {
    const options = action.payload;
    const baseCategories = (yield call(catalogApi.getBaseCatalogTrees, options.industry, 10)) as ICatalogTreeSlice[];
    yield put(CatalogActions.setBaseCategories(baseCategories));
  } catch (err) {
    console.error(err);
  }
}

export function* fetchCatalogSaga(action: ActionType<typeof CatalogActions.fetchCatalog>): SagaIterator {
  try {
    const options = action.payload;

    // run the sagas in parallel
    yield all([call(fetchBaseCategoriesSaga, CatalogActions.fetchBaseCategories(options))]);
  } catch (err) {
    console.error(err);
  }
}

export default function* catalogSaga(): SagaIterator {
  yield takeLeading(getType(CatalogActions.fetchCatalog), fetchCatalogSaga);
}
